import Image from '../../assets/Image.png';

const data = [
  {
    id: 1,
    category: 'backend',
    image: Image,
    title: 'Task Management Api',
    desc: 'Java & Spring Boot Project',
    demo: '',
    github: 'https://github.com/echatziosman/task-management-api',
  },
];

export default data;
